import { V2L2SmallModalRoot } from '../V2L2ModalRoot'
import { V2L2ModalTitlebar, V2L1ModalDismissButton } from '../V2ModalTitlebar'
import { V2L1ModalDetailLabel, V2L2ModalContent, V2L2ModalDetailRoot } from '../V2ModalContent'
import { V2L2ModalActionbar } from '../V2L2ModalActionbar'
import { V2L1ReasonableButton } from '../../Button/V2L1ReasonableButton'
import L1TextField from '../../../form/l1/L1TextField'
import { ComplexElementSize } from '../../../form/ComplexElementSize'
import { FusionColor } from '../../../../theme/FusionStyle'
import { faArrowLeftRotate, faGlasses, faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons'

interface V2L3ManageEncountersModalProps {
	canViewAdhoc: boolean
	canAudit: boolean
	loading: boolean
	value: string
	onChange?: React.ChangeEventHandler<HTMLInputElement>
	onViewClick?: React.MouseEventHandler<HTMLButtonElement>
	onPickClick?: React.MouseEventHandler<HTMLButtonElement>
	onReturnClick?: React.MouseEventHandler<HTMLButtonElement>
	onDismissClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const V2L3ManageEncountersModal = ({canViewAdhoc, canAudit, loading, value, onChange, onViewClick, onPickClick, onReturnClick, onDismissClick}: V2L3ManageEncountersModalProps) => {
	return (
		<V2L2SmallModalRoot>
			<V2L2ModalTitlebar
				title="Manage Encounter"
				buttons={<V2L1ModalDismissButton onClick={onDismissClick} />}
			/>
			<V2L2ModalContent>
				<V2L2ModalDetailRoot>
					<V2L1ModalDetailLabel>Encounter GUID</V2L1ModalDetailLabel>
					<L1TextField
						size={ComplexElementSize.FlexStretch}
						value={value}
						onChange={onChange}
						disabled={loading}
					/>
				</V2L2ModalDetailRoot>
			</V2L2ModalContent>
			<V2L2ModalActionbar>
				{canViewAdhoc ? (<V2L1ReasonableButton
					color={FusionColor.White}
					icon={faGlasses}
					label="View Form"
					loading={loading}
					onClick={onViewClick}
				/>) : null}
				{(loading || (!canAudit)) ? null : <>
					<V2L1ReasonableButton
						icon={faMagnifyingGlass}
						label="Pick for Audit"
						onClick={onPickClick}
					/>
					<V2L1ReasonableButton
						icon={faArrowLeftRotate}
						label="Return to Audit"
						onClick={onReturnClick}
					/>
				</>}
			</V2L2ModalActionbar>
		</V2L2SmallModalRoot>
	)
}
